/**
 * Directiva utilizada para obtener el formulario de asignación de las tareas
 */
AsignacionFormDirective.$inject = [];
export default function AsignacionFormDirective() {
    return {
        restrict: 'E',
        scope: {
            mostrarAsignacionAHijos: '='
        },
        template: require('./asignacion-form.html'),
        controller: 'AsignacionFormCtrl as asigCtrl'
    }
}